export const CAN_CREATE_COACH_PROFILES = '9e56b67a-bff1-4409-b6b2-c91318d85770'
export const CAN_EXPORT_COACH_PROFILES = 'd239bfcc-5068-4e90-85e1-83f6ab08da6b'
export const CAN_VIEW_COACH_LIST = '91e02981-e84b-4d1f-abff-359ca14fd81c'
export const CAN_CREATE_PARTICIPANT_PROFILES = 'ddeca9f7-8604-47d5-895f-eb62df6f6fa1'
export const CAN_SIGN_WAIVER_FOR_PARTICIPANT = 'ddeca9f7-8604-47d5-895f-eb62df6f6fa2'
export const CAN_EXPORT_PARTICIPANT_PROFILES = '3edc7862-9a3d-4139-a809-4a5823c50f30'
export const CAN_VIEW_PARTICIPANT_LIST = '730f919a-5097-4809-8aed-658bc4d1b359'
export const CAN_CHECK_IN_OUT_MEMBERS = '2e10c676-4744-40b6-93c0-29d6d91b53e2'
export const CAN_VIEW_CHECK_IN_OUT_MEMBERS = '63623691-287a-4b80-a1ea-dde86378aa6a'
export const CAN_EXPORT_CHECK_IN_OUT_MEMBERS = 'fc3c4ef9-b7a1-44a9-bd76-c943b8a63559'
export const CAN_CREATE_PROGRAMS = 'f7957e79-8d17-474c-8217-e3b9eaaddb3d'
export const CAN_CREATE_EVENTS = '33031d75-bed9-4efb-8706-8e886951d6ac'
export const IS_VIEW_ASSIGNED_ONLY = '79c8a051-4992-4a3c-b63f-d18e3b21b078'
export const CAN_ADD_IN_DROP_IN_PARTICIPANTS = '70726335-23fd-413a-8933-6dd840f1676b'
export const CAN_CREATE_POINTS = 'fae2b755-1dbc-4e41-b3ee-f6589330bde9'
export const CAN_REWARD_CHALLENGE_POINTS = '531fd915-6693-4f68-9d42-6457faef01e3'
export const CAN_REWARD_LIFE_SKILLS_POINTS = 'fe544409-3673-48f1-91ed-48c9a424c4c5'
export const CAN_ADD_ITEMS_TO_STORE = 'b07cdbbe-b3ae-419f-9f37-9c034df43aac'
export const CAN_CREATE_SURVEY = '8a5d4d0b-941a-4f92-b949-1a957bafaafd'
export const CAN_EXPORT_SURVEY_RESULTS = '52a11757-a2a8-4015-a334-d59e915349d1'
export const CAN_VIEW_REPORTS = '36f1feb2-1bd7-4ccb-9472-9dc6c3bac3b2'
export const CAN_CREATE_COMMUNICATIONS = '0e6809ac-ffea-455f-8568-c507e64340bd'
export const CAN_VIEW_SCHEDULE = '811174e4-6a2e-46e2-af0a-32a3217bf834'
export const CAN_VIEW_PROGRAMS = 'a14663f4-d293-40dc-9083-cc34e8eaeb36'
export const CAN_VIEW_EVENTS = '3c9943f6-7178-4e04-9569-6dd11c27cb0e'
export const CAN_VIEW_INBOX = '0107d337-2804-41ea-87e3-cba279e407f1'
export const CAN_VIEW_CHALLENGES = '006a096d-568d-435f-880f-8100f8389cf0'
export const CAN_VIEW_STORE = 'b77af1da-82b2-4a02-9d2b-0c1e266a6a89'
export const CAN_VIEW_LEADERBOARD = 'b77af1da-82b2-4a02-9d2b-0c1e266a6a90'
export const CAN_TAKE_ATTENDANCE = '72643a94-3c9d-4c8f-86b6-e869d22539b6'
export const CAN_EXPORT_PROGRAMS = 'f6b1f800-6039-457f-9fdc-8fb18fbe6eec'
export const CAN_EXPORT_EVENTS = 'e2962b74-d957-4dad-95a4-cb6b6b525e8d'
export const CAN_MANAGE_PARENT = '13d3177a-f07a-4eb1-bef2-b61a1528c18d'
export const KIOSK_PERMISSIONS = [
    CAN_VIEW_SCHEDULE,
    CAN_VIEW_PARTICIPANT_LIST,
    CAN_VIEW_CHECK_IN_OUT_MEMBERS,
    CAN_CHECK_IN_OUT_MEMBERS,
  ]

export const ROLE_LEVEL_ID_ORGANIZATION = '3e791ad1-a2d6-4f1d-a4bd-91437655bcd9' // should not be static

